import React, { Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto';
import { correspondenciaModo } from '../../../NuevaSolicitudCuenta/actions/NuevaSolicitudCuentaActions';


class DomicilioCheck extends Component {
    render() {

        const { domicilioObj, data, selectCheckBox } = this.props;
        const { tarjeta_credito, tarjeta_prepaga, domicilio } = data;
        let checkHabilitado, prepagaCheck, creditoCheck = null;
        prepagaCheck = domicilio.prepagoCheck;
        creditoCheck = domicilio.creditoCheck;

        checkHabilitado = data.tiposCuentaDisponibles;            
        

        

        return (
            <div className="row top-separator-xxs">
                <div className="col-xs-12 top-separator-xxs">
                    <label className="label-primary">{"Asociación a productos"}</label>
                </div>

                <div className="col-xs-12">
                    <CheckDefecto
                        nombre={"Prepaga"}
                        activo={checkHabilitado == 'TP' || checkHabilitado == 'ambas'}
                        check={prepagaCheck}
                        referencia={"Prepaga"}
                        selectCheckBox={(event) => selectCheckBox("Prepaga", event.target.checked)}
                    />
                </div>
                <div className="col-xs-12 left-separator-xs">
                    {tarjeta_prepaga.map((item, index) => {
                        const referencia = `${item.Id}Prepaga`;

                        return (
                            <CheckDefecto
                                key={index}
                                nombre={item.Descripcion}
                                check={item.Check}
                                activo={checkHabilitado == 'TP' && prepagaCheck}
                                referencia={referencia}
                                selectCheckBox={(event) => {
                                    if (checkHabilitado == 'TP') {
                                        selectCheckBox("tarjeta_prepaga", event.target.checked, item.Id);
                                    }
                                }}
                            />
                        )
                    })}
                </div>

                <div className="col-xs-12">
                    <CheckDefecto
                        nombre={"Crédito"}
                        activo={checkHabilitado == 'TC'|| checkHabilitado == 'ambas'}
                        check={creditoCheck}
                        referencia={"Credito"}
                        selectCheckBox={(event) => selectCheckBox("Credito", event.target.checked)}
                    />
                </div>
                <div className="col-xs-12 left-separator-xs">
                    {tarjeta_credito.map((item, index) => {
                        const referencia = `${item.Id}Credito`;

                        return (
                            <CheckDefecto
                                key={index}
                                nombre={item.Descripcion}
                                check={item.Check}
                                activo={checkHabilitado == 'TC' && creditoCheck}
                                referencia={referencia}
                                selectCheckBox={(event) => {
                                    if (checkHabilitado == 'TC') {
                                        selectCheckBox("tarjeta_credito", event.target.checked, item.Id);
                                    }
                                }}
                            />
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default DomicilioCheck;
